(function() {
  var root = document.getElementById("wl-memories");
  if (!root || root.dataset.ready === "true") return;
  root.dataset.ready = "true";

  var grid = document.getElementById("wl-memory-grid");
  var emptyState = document.getElementById("wl-memory-empty");
  var noResults = document.getElementById("wl-memory-no-results");
  var searchInput = document.getElementById("wl-memory-search");
  var petFilter = document.getElementById("wl-memory-pet-filter");
  var typeFilter = document.getElementById("wl-memory-type-filter");
  var favoritesFilter = document.getElementById("wl-favorites-filter");
  var sortSelect = document.getElementById("wl-memory-sort");
  var clearFilters = document.getElementById("wl-clear-filters");
  var memoryCount = document.getElementById("wl-memory-count");
  var favoriteCount = document.getElementById("wl-favorite-count");
  var draftCount = document.getElementById("wl-draft-count");
  var draftsSection = document.getElementById("wl-drafts-section");
  var draftList = document.getElementById("wl-draft-list");
  var modal = document.getElementById("wl-memory-modal");
  var modalMedia = document.getElementById("wl-modal-media");
  var modalTitle = document.getElementById("wl-modal-title");
  var modalType = document.getElementById("wl-modal-type");
  var modalMeta = document.getElementById("wl-modal-meta");
  var modalCaption = document.getElementById("wl-modal-caption");
  var modalTags = document.getElementById("wl-modal-tags");
  var modalFavorite = document.getElementById("wl-modal-favorite");
  var toast = document.getElementById("wl-memory-toast");

  var memories = readStorage("waglife_memories");
  var drafts = readStorage("waglife_memory_drafts");
  var activeMemoryId = "";
  var favoritesOnly = false;
  var toastTimer = null;

  function readStorage(key) {
    try {
      var parsed = JSON.parse(localStorage.getItem(key) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn("WagLife Memories storage error:", error);
      return [];
    }
  }

  function writeStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  function escapeHTML(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function showToast(message) {
    toast.textContent = message;
    toast.classList.add("is-visible");
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function() {
      toast.classList.remove("is-visible");
    }, 2400);
  }

  function formatDate(value) {
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return "Saved memory";

    return date.toLocaleDateString([], {
      month: "short",
      day: "numeric",
      year: date.getFullYear() !== new Date().getFullYear() ? "numeric" : undefined
    });
  }

  function uniqueValues(items, key) {
    var seen = {};
    return items
      .map(function(item) { return item[key]; })
      .filter(function(value) {
        if (!value || seen[value]) return false;
        seen[value] = true;
        return true;
      })
      .sort();
  }

  function populateFilters() {
    var pets = uniqueValues(memories, "pet");
    var types = uniqueValues(memories, "type");

    petFilter.innerHTML = '<option value="">All pets</option>';
    typeFilter.innerHTML = '<option value="">All types</option>';

    pets.forEach(function(pet) {
      var option = document.createElement("option");
      option.value = pet;
      option.textContent = pet;
      petFilter.appendChild(option);
    });

    types.forEach(function(type) {
      var option = document.createElement("option");
      option.value = type;
      option.textContent = type;
      typeFilter.appendChild(option);
    });
  }

  function updateStats() {
    memoryCount.textContent = String(memories.length);
    favoriteCount.textContent = String(memories.filter(function(item) {
      return Boolean(item.favorite);
    }).length);
    draftCount.textContent = String(drafts.length);
  }

  function getFilteredMemories() {
    var query = searchInput.value.trim().toLowerCase();
    var pet = petFilter.value;
    var type = typeFilter.value;
    var sort = sortSelect.value;

    var filtered = memories.filter(function(memory) {
      var searchable = [
        memory.title,
        memory.caption,
        memory.location,
        memory.pet,
        memory.type,
        (memory.tags || []).join(" ")
      ].join(" ").toLowerCase();

      if (query && searchable.indexOf(query) === -1) return false;
      if (pet && memory.pet !== pet) return false;
      if (type && memory.type !== type) return false;
      if (favoritesOnly && !memory.favorite) return false;
      return true;
    });

    filtered.sort(function(a, b) {
      if (sort === "oldest") {
        return new Date(a.createdAt) - new Date(b.createdAt);
      }

      if (sort === "title") {
        return String(a.title || "").localeCompare(String(b.title || ""));
      }

      return new Date(b.createdAt) - new Date(a.createdAt);
    });

    return filtered;
  }

  function buildTagHTML(tags, limit) {
    return (tags || []).slice(0, limit || 3).map(function(tag) {
      return "<span>" + escapeHTML(tag) + "</span>";
    }).join("");
  }

  function buildMemoryCard(memory) {
    var previewStyle = memory.preview
      ? ' style="background-image:url(\'' + escapeHTML(memory.preview) + '\')"'
      : "";

    return [
      '<article class="wl-memory-card" data-memory-id="' + escapeHTML(memory.id) + '">',
        '<div class="wl-memory-card__media"' + previewStyle + '>',
          memory.preview ? "" : '<span aria-hidden="true">🐾</span>',
          '<span class="wl-memory-card__badge">' + escapeHTML((memory.type || "Memory").toUpperCase()) + '</span>',
          '<button class="wl-memory-card__favorite' + (memory.favorite ? " is-active" : "") + '"',
            ' type="button" data-memory-action="toggle-favorite" data-memory-id="' + escapeHTML(memory.id) + '"',
            ' aria-label="Favorite memory">★</button>',
        '</div>',
        '<div class="wl-memory-card__body">',
          '<div class="wl-memory-card__meta">',
            '<span>' + escapeHTML(formatDate(memory.createdAt)) + '</span>',
            '<span>' + escapeHTML(memory.pet || "My Dog") + '</span>',
          '</div>',
          '<h3>' + escapeHTML(memory.title || "New Memory") + '</h3>',
          '<p>' + escapeHTML(memory.caption || memory.location || "A good day worth remembering.") + '</p>',
          '<div class="wl-memory-card__tags">' + buildTagHTML(memory.tags, 3) + '</div>',
        '</div>',
      '</article>'
    ].join("");
  }

  function renderMemories() {
    var filtered = getFilteredMemories();

    grid.innerHTML = filtered.map(buildMemoryCard).join("");

    var hasAny = memories.length > 0;
    var hasFiltered = filtered.length > 0;

    emptyState.hidden = hasAny;
    grid.hidden = !hasFiltered;
    noResults.hidden = !hasAny || hasFiltered;
  }

  function renderDrafts() {
    draftsSection.hidden = drafts.length === 0;

    draftList.innerHTML = drafts.map(function(draft) {
      var style = draft.preview
        ? ' style="background-image:url(\'' + escapeHTML(draft.preview) + '\')"'
        : "";

      return [
        '<article class="wl-draft-card">',
          '<div class="wl-draft-card__thumb"' + style + '>',
            draft.preview ? "" : '<span aria-hidden="true">🐾</span>',
          '</div>',
          '<div>',
            '<small>DRAFT · ' + escapeHTML(formatDate(draft.createdAt)) + '</small>',
            '<strong>' + escapeHTML(draft.title || "Untitled Memory") + '</strong>',
            '<p>' + escapeHTML(draft.pet || "My Dog") + ' · ' + escapeHTML(draft.type || "Memory") + '</p>',
          '</div>',
          '<a href="/pages/new-memory">Continue Editing</a>',
        '</article>'
      ].join("");
    }).join("");
  }

  function renderAll() {
    populateFilters();
    updateStats();
    renderMemories();
    renderDrafts();
  }

  function findMemory(id) {
    return memories.find(function(memory) {
      return memory.id === id;
    });
  }

  function openMemory(id) {
    var memory = findMemory(id);
    if (!memory) return;

    activeMemoryId = id;
    modalTitle.textContent = memory.title || "New Memory";
    modalType.textContent = String(memory.type || "Memory").toUpperCase();
    modalMeta.textContent = [
      formatDate(memory.createdAt),
      memory.pet || "My Dog",
      memory.location || ""
    ].filter(Boolean).join(" · ");
    modalCaption.textContent = memory.caption || "A good day worth remembering.";
    modalTags.innerHTML = buildTagHTML(memory.tags, 20);
    modalFavorite.classList.toggle("is-active", Boolean(memory.favorite));

    modalMedia.style.backgroundImage = memory.preview
      ? "url('" + memory.preview + "')"
      : "";
    modalMedia.innerHTML = memory.preview ? "" : '<span aria-hidden="true">🐾</span>';

    modal.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    modal.hidden = true;
    activeMemoryId = "";
    document.body.style.overflow = "";
  }

  function toggleFavorite(id) {
    var memory = findMemory(id);
    if (!memory) return;

    memory.favorite = !memory.favorite;
    writeStorage("waglife_memories", memories);
    updateStats();
    renderMemories();

    if (activeMemoryId === id) {
      modalFavorite.classList.toggle("is-active", Boolean(memory.favorite));
    }

    showToast(memory.favorite ? "Added to favorites" : "Removed from favorites");
  }

  function deleteMemory(id) {
    var memory = findMemory(id);
    if (!memory) return;

    var confirmed = window.confirm('Delete "' + (memory.title || "this memory") + '"?');
    if (!confirmed) return;

    memories = memories.filter(function(item) {
      return item.id !== id;
    });

    writeStorage("waglife_memories", memories);
    closeModal();
    renderAll();
    showToast("Memory deleted");
  }

  function shareMemory(id) {
    var memory = findMemory(id);
    if (!memory) return;

    var shareText = [
      memory.title || "WagLife Memory",
      memory.caption || "",
      memory.location || ""
    ].filter(Boolean).join("\n");

    if (navigator.share) {
      navigator.share({
        title: memory.title || "WagLife Memory",
        text: shareText
      }).catch(function() {});
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareText).then(function() {
        showToast("Memory details copied");
      });
      return;
    }

    showToast("Sharing is not available on this device");
  }

  function clearAllFilters() {
    searchInput.value = "";
    petFilter.value = "";
    typeFilter.value = "";
    favoritesOnly = false;
    favoritesFilter.classList.remove("is-active");
    favoritesFilter.setAttribute("aria-pressed", "false");
    sortSelect.value = "newest";
    renderMemories();
  }

  root.addEventListener("click", function(event) {
    var actionButton = event.target.closest("[data-memory-action]");

    if (actionButton) {
      var action = actionButton.dataset.memoryAction;
      var id = actionButton.dataset.memoryId || activeMemoryId;

      if (action === "toggle-favorite") {
        event.stopPropagation();
        toggleFavorite(id);
        return;
      }

      if (action === "close-modal") {
        closeModal();
        return;
      }

      if (action === "toggle-modal-favorite") {
        toggleFavorite(activeMemoryId);
        return;
      }

      if (action === "delete-memory") {
        deleteMemory(activeMemoryId);
        return;
      }

      if (action === "share-memory") {
        shareMemory(activeMemoryId);
        return;
      }

      if (action === "edit-memory") {
        showToast("Memory editing is coming next");
        return;
      }
    }

    var card = event.target.closest(".wl-memory-card");
    if (card) {
      openMemory(card.dataset.memoryId);
    }
  });

  searchInput.addEventListener("input", renderMemories);
  petFilter.addEventListener("change", renderMemories);
  typeFilter.addEventListener("change", renderMemories);
  sortSelect.addEventListener("change", renderMemories);

  favoritesFilter.addEventListener("click", function() {
    favoritesOnly = !favoritesOnly;
    favoritesFilter.classList.toggle("is-active", favoritesOnly);
    favoritesFilter.setAttribute("aria-pressed", String(favoritesOnly));
    renderMemories();
  });

  clearFilters.addEventListener("click", clearAllFilters);

  document.addEventListener("keydown", function(event) {
    if (event.key === "Escape" && !modal.hidden) {
      closeModal();
    }
  });

  renderAll();
})();
